
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/improving-your-lexical-resource",
      function () {
        return require("private-next-pages/elearning/improving-your-lexical-resource.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/improving-your-lexical-resource"])
      });
    }
  